export default "__VITE_ASSET__B_VXWii3__"